import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Switch } from '../../../../../../components/Switch/Switch';
import { DatePicker, DateRange } from '../../../../../../components/DatePicker/DatePicker';
import { getFinishDateForSchoolYear } from '../../../../../../helpers/calendar/calendar';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

// report 047
export function SchoolTournamentScheduleReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  const dateTo = getFinishDateForSchoolYear(now);

  const requestInitial = {
    dateFrom: now,
    dateTo,
    isShowBooked: true,
    isShowWaitingList: true,
    isShowAvailableForBooking: true,
    isShowCancelledPostponed: false,
    isShowUnavailableForBooking: false
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.SCHOOL_TOURNAMENT_SCHEDULE)}
      initialValues={requestInitial}>
      
      {({ values, setFieldValue }) => (
        <Form className="tournamentReportFormModern">
          <div className="bReportFormTitle">Tournament schedule</div>
          <div className="mb-3 mt-3">View tournaments your school can enter or is already involved in.</div>
          <div className="tournamentReportFormModern__dateRange">
            <DatePicker
              label="Tournament dates"
              mode="range"
              value={{ start: values.dateFrom, end: values.dateTo }}
              onChange={value => {
                const range = value as DateRange;
                if (range.start) setFieldValue('dateFrom', range.start);
                if (range.end) setFieldValue('dateTo', range.end);
              }}
              numberOfMonths={2}
              presets
              centered
              clearable={false}
              format="DD MMM YYYY"
            />
          </div>
          <div className="tournamentReportFormModern__options">
            {[
              ['isShowBooked', 'Booked tournaments', 'Your school is already a participant.'],
              ['isShowWaitingList', 'Waiting list', 'Your school is waiting for a place.'],
              ['isShowAvailableForBooking', 'Available for booking', 'Your school can currently book a place.'],
              ['isShowCancelledPostponed', 'Cancelled or postponed', 'Include tournaments that will not run as planned.'],
              ['isShowUnavailableForBooking', 'Unavailable for booking', 'Include tournaments that cannot currently be booked.']
            ].map(([name, label, hint]) => (
              <div className="tournamentReportFormModern__option" key={name}>
                <div><strong>{label}</strong><small>{hint}</small></div>
                <Switch
                  name={name}
                  value={(values as any)[name]}
                  onChange={event => setFieldValue(name, event.target.checked)}
                />
              </div>
            ))}
          </div>

          <div className="tournamentReportFormModern__footer">
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>Cancel</button>
            <button type="submit" className="btn btn-primary">Generate report</button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
